import { Typography } from '@montugroup/design-system';
import { useTheme } from '@mui/material/styles';
import type { ReactNode } from 'react';
import { LineItemRoot } from './Styles';

interface LineItemProps {
  label: string;
  amount: number | string | ReactNode;
  isTotal?: boolean;
  isDiscount?: boolean;
  isInvalid?: boolean;
}

export function LineItem(props: LineItemProps) {
  const theme = useTheme();
  const { label, amount, isTotal, isDiscount, isInvalid } = props;

  const variant = isTotal ? 'subtitle2' : 'body2';

  const getColor = () => {
    if (isInvalid) {
      return theme.palette.text.disabled;
    }

    if (isDiscount) {
      return theme.palette.success.main;
    }

    return theme.palette.text.primary;
  };

  return (
    <LineItemRoot>
      <Typography variant={variant}>{label}</Typography>
      <Typography
        variant={variant}
        component={isInvalid ? 's' : 'p'}
        sx={(theme) => ({
          fontWeight: isInvalid ? 400 : 600,
          color: getColor(),
          marginLeft: theme.spacing(4),
        })}
      >
        {amount}
      </Typography>
    </LineItemRoot>
  );
}
